// complete    Survey successfully completed and user can be rewarded
// terminate   Survey was rejected
// quota_full  Survey has enough respondents for the user profile
// screenout   User did not qualify for the survey
// timeout     User abandoned the survey
// fraud   Survey was rejected due to fraudulent activity (VPN/Proxy use, speeders, straightliners, gibberish, etc.)
// taken   User has already taken the survey (potentially on another platform or with a duplicate account)
// not_available   Survey not available (survey closed, full, etc.)
// used_link   Survey url has already been used to enter the survey (users cannot re enter a survey once they have attempted it)
// expired_link    Survey url has expired (old urls are likely to be for surveys that are no longer available - ensure the list of available surveys is refreshed regularly)
export const TERMINATE_MESSAGES: { [status: string]: { title: string; description: string } } = {
  terminate: {
    title: 'Thanks for giving this a go.',
    description:
      'But it looks like this survey finishes here for you today. Let’s find you another one.',
  },
  quota_full: {
    title: 'Looks like this was a popular survey.',
    description: "We have received enough responses for this survey, so it's now closed.",
  },
  screenout: {
    title:
      "We had to ask you a few questions before we could be sure, unfortunately this survey isn't for you",
    description: 'We can see if there are others you could try.',
  },
  timeout: {
    title: 'This survey closed before you could complete it. Sorry about that!',
    description: 'Got time for another?',
  },
  fraud: {
    title:
      'We had to stop your participation in this survey. Could it be something you did without realising?',
    description:
      "You can avoid this happening again. Make sure you're reading all the questions, give consistent answers.",
  },
  taken: {
    title: "Looks like you've already taken part in this survey.",
    description:
      'If you opened this survey in another device, browser or tab, please continue there.',
  },
  used_link: {
    title: "Looks like you've already taken part in this survey but somehow got to start it again.",
    description:
      'If you have opened this in another tab, try closing it and carry on with the original survey.',
  },
  not_available: {
    title: 'This survey is now closed.',
    description: 'We apologize for any inconvenience this may have caused.',
  },
  expired_link: {
    title: 'This survey link is no longer valid.',
    description:
      "If you need help with this, please contact Helpdesk. Or if you have time for another survey, let's look for another survey for you.",
  },
};
